import { render, staticRenderFns } from "./SettingColumnItem.vue?vue&type=template&id=3c42a000&"
import script from "./SettingColumnItem.vue?vue&type=script&lang=ts&"
export * from "./SettingColumnItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports